<% var component = new Anvil.models.components.List(name, list, search_fields, template, params) %>
<div anvil-component="<%- component.id %>" id="<%- component.name %>_list"></div>
